import { useEffect } from 'react';
import { useParams } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import { useCompanyActiveSystems } from '@/hooks/useCompanyActiveSystems';
import { DashboardEditor } from '@/components/dashboard/DashboardEditor';
import { useDashboardLayout } from '@/hooks/use-dashboard-layout';
import { registerAllWidgets } from '@/lib/widgets/widget-definitions';
import { Skeleton } from '@/components/ui/skeleton';
import { TrialBanner } from '@/components/company/TrialBanner';

export default function CompanyAdminDashboard() {
  const { slug } = useParams<{ slug: string }>();
  const { companies } = useAuth();
  const company = companies.find(c => c.slug === slug);
  const { data: activeSystems = [], isLoading: systemsLoading } = useCompanyActiveSystems(company?.id);
  const { layout, saveLayout, isLoading: layoutLoading } = useDashboardLayout({
    layoutType: 'admin',
    companyId: company?.id
  });

  // Register all available widgets
  useEffect(() => {
    registerAllWidgets();
  }, []);

  // Get enabled system codes
  const enabledSystems = activeSystems.map(system => system.code);

  if (systemsLoading || layoutLoading) {
    return (
      <div className="space-y-6">
        <div className="space-y-2">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-4 w-96" />
        </div>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          {[1, 2, 3, 4].map(i => (
            <Skeleton key={i} className="h-32" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <>
      {company?.id && company?.slug && <TrialBanner companyId={company.id} companySlug={company.slug} />}
      
      <div className="space-y-6">
        <div className="space-y-2">
          <h1 className="text-3xl font-bold tracking-tight">
            Painel Administrativo - {company?.name}
          </h1>
          <p className="text-muted-foreground">
            Personalize seu dashboard administrativo com widgets dos sistemas liberados para sua empresa.
          </p>
        </div>

        <DashboardEditor
          enabledSystems={enabledSystems}
          initialLayout={layout || undefined}
          onSaveLayout={saveLayout}
        />
      </div>
    </>
  );
}